// extracted by mini-css-extract-plugin
export default {"modal":"MoveCandidateGroupModal-module__modal__bK81u","detail":"MoveCandidateGroupModal-module__detail__ZJip0","content":"MoveCandidateGroupModal-module__content__aF32u"};